<div class="tile-padding-first tile-padding">
  <ng-template #utilityBarForm>
    <label class="tw:text-danger">{{errorMsg}}</label>
    <form [formGroup]="frmSessionSearch">
      <div class="flex-search-container tw:pb-6" [class.filter-bar]="filtersEnabled">
        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
          @if (showSearchExtraColumns) {
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <div>
                <label class="field__label">Tutor</label>
                <app-typeahead inputClass="field__control body-content" placeholder="Tutor" formControlName="tutor"
                  data-toggle="tooltip" data-placement="top" title="Please enter the tutor name"
                  [enabled]="autocompleteEnabled" [source]="suggest.tutors" [displayWith]="suggest.name"></app-typeahead>
              </div>
              </div>
            }
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <div>
                <label class="field__label">Learner</label>
                <input class="field__control body-content" placeholder="Learner" formControlName="student" type="text"
                  data-toggle="tooltip" data-placement="top" [title]="pupilPlaceholderTooltip" />
              </div>
              </div>
              @if (showSearchExtraColumns) {
                <div fxLayout.gt-md="column" class="filter-bar__field">
                  <div>
                    <label class="field__label">Client Referrer</label>
                    <app-typeahead inputClass="field__control body-content" placeholder="Client Referrer" formControlName="clientReferrer"
                      data-toggle="tooltip" data-placement="top" title="Please enter the client referrer"
                      [enabled]="autocompleteEnabled" [source]="suggest.referrers" [displayWith]="suggest.name"></app-typeahead>
                  </div>
                  </div>
                }
                <div fxLayout.gt-md="column" class="filter-bar__field">
                  <div>
                    <label class="field__label">Client</label>
                    <app-typeahead inputClass="field__control body-content" placeholder="Client" formControlName="client"
                      data-toggle="tooltip" data-placement="top" title="Please enter the client"
                      [enabled]="autocompleteEnabled" [source]="clientSuggestions.search" [prefetch]="clientSuggestions.prefetch" [displayWith]="clientSuggestions.display" [valueWith]="clientSuggestions.value"></app-typeahead>
                  </div>
                  </div>
                  <div fxLayout.gt-md="column" class="filter-bar__group" *appFeatureSwitch="featureKeys.filtersSessionSearch">
                    <app-brand-filter class="filter-bar__field" [companyIds]="companyIds"
                      (companyIdsChange)="companyIds = $event"></app-brand-filter>
                  </div>
                </div>
                <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group"
                  *appFeatureSwitch="featureKeys.filtersSessionSearch" id="sessionSearchFilters">
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <label class="field__label" for="sessionOrderTypeFilter">Order type</label>
                    <select id="sessionOrderTypeFilter" class="field__control body-content" [ngModel]="aPorSP" [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="aPorSP = $event" title="Filter by AP or SP">
                      <option [ngValue]="null">All</option>
                      @for (option of orderTypeOptions; track option.value) {
                        <option [ngValue]="option.value">{{option.label}}</option>
                      }
                    </select>
                  </div>
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <label class="field__label">Report status</label>
                    <app-searchable-select multiple [items]="reportStatusOptions" displayField="label" valueField="value"
                      placeholder="Any report status" searchPlaceholder="Search…"
                      [ngModel]="reportStatuses" [ngModelOptions]="{ standalone: true }"
                      (selectionChange)="reportStatuses = $event"></app-searchable-select>
                  </div>
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <label class="field__label">Attendance</label>
                    <app-searchable-select multiple [items]="attendanceOutcomeOptions" displayField="label" valueField="value"
                      placeholder="Any attendance" searchPlaceholder="Search…"
                      [ngModel]="attendanceOutcomes" [ngModelOptions]="{ standalone: true }"
                      (selectionChange)="attendanceOutcomes = $event"></app-searchable-select>
                  </div>
                </div>
                <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
                  @if (showSearchExtraColumns) {
                    <div fxLayout.gt-md="column" class="filter-bar__field">
                      <crm-user-select></crm-user-select>
                    </div>
                  }
                  <div fxLayout.gt-md="column" class="filter-bar__field">
                    <div>
                      <label class="field__label">Date From</label>
                      <input type="date" class="field__control" formControlName="startDate" required (input)="datePreset = null"
                        data-toggle="tooltip" data-placement="top" title="Please select the from date">
                      @if (frmSessionSearch.controls.startDate.invalid && frmSessionSearch.controls.startDate.touched) {
                        <span class="field__error">Enter Date From</span>
                      }
                      </div>
                    </div>
                    <div fxLayout.gt-md="column" class="filter-bar__field">
                      <div>
                        <label class="field__label">Date To</label>
                        <input type="date" class="field__control" formControlName="endDate" required (input)="datePreset = null"
                          data-toggle="tooltip" data-placement="top" title="Please select the to date">
                        @if (frmSessionSearch.controls.endDate.invalid && frmSessionSearch.controls.endDate.touched) {
                          <span class="field__error">Enter Date To</span>
                        }
                        </div>
                      </div>
                      <div fxLayout.gt-md="column" class="filter-bar__field">
                        <div>
                          <label class="field__label">Delivery</label>
                          <!-- [ngValue] on every option (not value=) so "All" binds a real null rather
                               than the empty string; the API treats both as "no filter", but null is
                               what the other unset filters on this form send. -->
                          <select class="field__control body-content" formControlName="deliveryMode"
                            data-toggle="tooltip" data-placement="top" title="Filter by online or in-person delivery">
                            <option [ngValue]="null">All</option>
                            <option [ngValue]="'Online'">Online</option>
                            <option [ngValue]="'In person'">In person</option>
                          </select>
                        </div>
                      </div>
                      @if (!filtersEnabled) {
                        <div fxLayout.gt-md="column">
                          <div><label class="field__label tw:invisible">&nbsp;</label></div>
                          <button class="btn-outline-primary btn" style="height: 38px;" name="Search" value="Search" (click)="searchSession()">Search</button>
                        </div>
                      }
                    </div>
                    @if (filtersEnabled) {
                      <div class="filter-bar__actions">
                        <div class="filter-bar__presets">
                          <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
                        </div>
                        <div class="filter-bar__buttons">
                          <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                          <button class="btn btn-primary" name="Search" value="Search" (click)="searchSession()">Search</button>
                        </div>
                      </div>
                    }
                  </div>
                </form>
              </ng-template>

              <div class="grid-primary">
                <div class="tile-padding">
                  @if (recordCount !== null) {
                    <div>
                      <div class="header-tile">Sessions</div>
                      <app-data-table
                        [columns]="columns"
                        [data]="rows"
                        [serverSide]="true"
                        [totalCount]="totalCount"
                        [pageSize]="pageSize"
                        [sortField]="sortField"
                        [sortDir]="sortDir"
                        [loading]="loading"
                        [tableId]="tableId"
                        [emptyMessage]="searchResultText || 'No results found'"
                        (rowClick)="onDataclicked($event)"
                        (pageChange)="onPageChange($event)"
                        (sortChange)="onSortChange($event)">
                        <ng-template appColumnCell="time" let-element>
                          {{element.startDate | date : 'HH:mm'}} - {{element.endDate | date : 'HH:mm'}}
                        </ng-template>
                        <ng-template appColumnCell="student" let-element>
                          <span class="tw:w-full tw:items-center tw:flex">
                            <div class="student-group-icon-container tw:mr-2 tw:float-left"
                              [ngClass]="{'single-student-icon': !element.isGroupPlacement,
                                            'group-one-student-icon': element.isGroupPlacement && element.groupSize == 1,
                                            'group-two-student-icon': element.isGroupPlacement && element.groupSize == 2,
                                            'group-three-student-icon': element.isGroupPlacement && element.groupSize == 3,
                                            'group-multiple-student-icon': element.isGroupPlacement && element.groupSize > 3}"></div>{{element.isGroupPlacement == true ? element.groupName : element.student}}
                          </span>
                        </ng-template>
                      </app-data-table>
                    </div>
                  }
    </div>
  </div>
</div>
